import { Component, OnInit } from '@angular/core';
import { TrackingService} from "../../services/tracking.service";
import { Observable } from 'rxjs';
import {AuthService } from '../../services/auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { NgxNavigationWithDataComponent } from 'ngx-navigation-with-data';

declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.sass']
})
export class DashboardComponent implements OnInit {
  public SITE_KEY:String = "6LelSZgaAAAAAKQpp3wmgRWWOVaQSJuBpkdLZMby";
  public isLogin: Observable<boolean>;

  public sendForm = this.fb.group({
    id: ['', Validators.required],
    captcha:['', Validators.required]
  });
  public errors = null;

  constructor(
    private trService:TrackingService,
    private authService: AuthService,
    private fb: FormBuilder,
    private navCtrl: NgxNavigationWithDataComponent) { 
    this.isLogin = this.authService.isSignedInStream;
  }

ngOnInit(): void {}
  
async resolved(captchaResponse: string) {
  await this.sendForm.controls['captcha'].setValue(captchaResponse);
}

edit(e:any){
  e.preventDefault();
  if(!this.sendForm.invalid){
    this.navCtrl.navigate('tracking/edit', {id: this.sendForm.get("id")?.value ?? ""});
  }
}

search(e:any){
  e.preventDefault();
  if(!this.sendForm.invalid){
    this.navCtrl.navigate('tracking', {id: this.sendForm.get("id")?.value ?? ""});
  }
}

}
